import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Radium from 'radium'
import ReactTable from 'react-table'

import { getOrganizationUserArray } from './../../../../selectors/Admin'

import TEHelmet from './../../../../component/TEHelmet'
import TEButton from './../../../../component/Form/TEButton'

import PanelWrapper from './../../../../component/Layout/PanelWrapper'
import Panel from './../../../../component/Layout/Panel'

import CreateUserPopup from './CreateUserPopup'

import { tableColumns } from './tableConfigs'
import { customTableFilter } from './../../../../helpers'
import styles from './styles'

class Organizations extends Component {
	state = { createUserVisible: false }
	render() {
		const meta = {
			title: 'Rittal | Admin Users',
			description: '',
		}
		const { createUserVisible } = this.state
		const { match, userArray } = this.props
		const { uid } = match.params
		return (
			<Fragment>
				<TEHelmet {...meta} />
				<PanelWrapper>
					<Panel
						title="Organization Users"
						rightComponent={
							<TEButton
								onClick={() => this.setState({ createUserVisible: true })}
								style={styles.actionButton}
							>
								Create User
							</TEButton>
						}
					>
						<div style={styles.tableContainer}>
							<ReactTable
								data={userArray}
								columns={tableColumns(uid)}
								defaultPageSize={10}
								filterable
								defaultFilterMethod={customTableFilter}
								defaultSorted={[
									{
										id: 'name',
										desc: false,
									},
								]}
							/>
						</div>
					</Panel>
				</PanelWrapper>

				<CreateUserPopup
					visible={createUserVisible}
					onClose={() => this.setState({ createUserVisible: false })}
					orgUID={uid}
				/>
			</Fragment>
		)
	}
}

Organizations.propTypes = {}

Organizations.defaultProps = {}

const mapStateToProps = (state) => {
	const userArray = getOrganizationUserArray(state)
	return { userArray }
}

export default connect(
	mapStateToProps,
	{}
)(Radium(Organizations))
